/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    fetchLocations,
    fetchCountries,
    addLocations,
    addLocationsRenewals,
    addLocationsSecurity,
    deleteLocation,
    submitStep02,
    resetQuotes,
    findLatLong,
    getRenewalVariation,
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step02 from '../../../components/pages/Quote/Step02/Step02'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: 'The QUOTE! Step02',
        riskLocations: state.quote.riskLocations,
        countries: state.step00.countries,
        checkStep: state.quote.checkStep,
    }
}

export default connect(mapStateToProps, {
    fetchLocations,
    fetchCountries,
    addLocations,
    addLocationsRenewals,
    addLocationsSecurity,
    deleteLocation,
    submitStep02,
    resetQuotes,
    getLatLong: findLatLong,
    getRenewalVariation,
})(Step02)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step02.tsx